import React from "react";
import Typography from "@mui/material/Typography";

const EXCEPTIONAL_KEY = ["Item_Nbr", "vendor_name"];

const OSOAccordionTitle = (props) => {
  const { type, currentDetails, headerDetails } = props;

  const classMappings = {
    Department: ["fl_dept_name"],
    Category: ["fl_dept_name", "fl_class_name"],
    Planogram: ["fl_dept_name", "fl_class_name", "fl_sub_name"],
    "Planogram #": [...headerDetails, "PlanogramName"],
    SKU: ["PlanogramName", "PlanogramNumber", "Item_Nbr"],
    Vendor: [...headerDetails, "vendor_name"],
  };

  const checkTitle = (key) => {
    if (EXCEPTIONAL_KEY.includes(key)) {
      const sampleItem = currentDetails?.subRows[0];
      return sampleItem[key]?.toString()?.trim();
    }
    return currentDetails[key]?.toString()?.trim();
  };

  const getTitle = () => {
    const currentTypes = classMappings[type];
    return currentTypes?.reduce((acc, details, i) => {
      const currentTitle = checkTitle(details) ?? "";
      let title = currentDetails[details];
      if (details === "vendor_name") {
        title = currentTitle;
      }
      const combinedTitle = currentTitle?.length ? `| ${currentTitle}` : "";
      acc = i === 0 ? `${title}` : `${acc} ${combinedTitle}`;
      return acc;
    }, "");
  };

  return (
    <>
      <Typography sx={{ mr: 1, flexShrink: 0 }}>
        {type === "Planogram #" ? "Planogram" : type}:
      </Typography>
      <Typography sx={{ color: "text.secondary", fontWeight: "bold" }}>
        {getTitle()}
      </Typography>
    </>
  );
};

export default React.memo(OSOAccordionTitle);
